import { getConfigForLocale } from '../config/five9ChatConfig'
import { Five9ChatConfig } from '../five9Chat'

declare const FIVE9_ENV: string
declare const Five9SocialWidget: any

export type InitializeChatParams = {
  locale: string
  options?: {
    title?: string
    profiles?: string
  }
}

export type LoadChatResponse = {
  isWidgetAdded: boolean
}

export type InitializeChatResponse = {
  isLocaleSupported: boolean
  isChatLoaded: boolean
}

window.onload = () => {
  if (typeof FIVE9_ENV !== 'undefined') console.log('[five9-chat] FIVE9_ENV', FIVE9_ENV)
  else console.log('[five9-chat] FIVE9_ENV undefined!')
}

function loadChat(config: Five9ChatConfig) {
  return new Promise<LoadChatResponse>((resolve, reject) => {
    try {
      const script = document.createElement('script')
      script.setAttribute('src', 'https://app.five9.com/consoles/SocialWidget/five9-social-widget.min.js')
      script.onload = () => {
        Five9SocialWidget.addWidget(config)
        resolve({ isWidgetAdded: true })
      }

      document.body.appendChild(script)
    } catch (e) {
      console.log('[five9-chat] Error: Five9 Widget not loaded!')
      reject({ isWidgetAdded: false })
    }
  })
}

export function initializeChat({ locale, options }: InitializeChatParams) {
  return new Promise<InitializeChatResponse>(async (resolve, reject) => {
    const result = { isLocaleSupported: false, isChatLoaded: false }

    try {
      console.log('[five9-chat] initializeChat:locale', locale)
      console.log('[five9-chat] initializeChat:options', options)

      const config = getConfigForLocale(locale)
      if (config) {
        result.isLocaleSupported = true
        // Validate options
        if (typeof options !== 'undefined') {
          const { title, profiles } = options
          config.title = typeof title !== 'undefined' ? title : config.title
          config.profiles = typeof profiles !== 'undefined' ? profiles : config.profiles
        }
        const { isWidgetAdded } = await loadChat(config)
        result.isChatLoaded = isWidgetAdded
      } else {
        console.log('[five9-chat] Five9 Chat does not support locale:', locale)
      }
      resolve(result)
    } catch (e) {
      console.log('[five9-chat] Error: Five9 Chat not initialized!')
      reject({ isChatLoaded: result })
    }
  })
}
